const LIMIT_SIZE = 3 // 默认显示的个数

/**
 * @isHandle {boolean} isHandle： 是否是手动点击
 */
function applyFilters(isHandle = false) {
  let selectedFilters1 = Array.from(document.querySelectorAll('#myBtnContainer input:checked')).map(
    (input) => input.value
  )
  let selectedFilters2 = Array.from(document.querySelectorAll('#myBtnContainer1 input:checked')).map(
    (input) => input.value
  )

  let filterDivs = document.getElementsByClassName('filterDiv')
  let anyFiltersSelected = selectedFilters1.length > 0 || selectedFilters2.length > 0

  for (let i = 0; i < filterDivs.length; i++) {
    filterDivs[i].style.display = 'none'
    filterDivs[i].classList.remove('hide')
    if (anyFiltersSelected) {
      filterDivs[i].classList.remove('dehide')
    }
  }

  for (let i = 0; i < filterDivs.length; i++) {
    let element = filterDivs[i]
    let showElement =
      (selectedFilters1.length === 0 || selectedFilters1.some((filter) => element.classList.contains(filter))) &&
      (selectedFilters2.length === 0 || selectedFilters2.some((filter) => element.classList.contains(filter)))
    if (showElement) {
      element.style.display = 'block'
    } else {
      element.classList.add('hide')
    }
  }

  let contentFilters = document.getElementsByClassName('content-filter')
  for (let i = 0; i < contentFilters.length; i++) {
    let contentFilter = contentFilters[i]
    let visibleChildren = Array.from(contentFilter.getElementsByClassName('filterDiv')).some(
      (filterDiv) => filterDiv.style.display === 'block'
    )
    if (visibleChildren) {
      contentFilter.style.display = 'block'
    } else {
      contentFilter.style.display = 'none'
    }
  }

  const viewMoreButtons = document.querySelectorAll('.view-more')
  viewMoreButtons.forEach((button) => {
    const parentContentFilter = button.closest('.content-filter')
    const parentFilterDivs = parentContentFilter.querySelectorAll('.filterDiv')
    const visibleParentFilterDivs = Array.from(parentFilterDivs).filter((div) => div.style.display === 'block')
    if (visibleParentFilterDivs.length <= LIMIT_SIZE) {
      button.style.display = 'none'
      visibleParentFilterDivs.forEach((div) => div.classList.remove('dehide'))
    } else {
      console.log('visibleParentFilterDivs.length >>>', visibleParentFilterDivs.length, isHandle)
      if (isHandle) {
        // 只有手动切换checkbox才需要更新
        const btnTextClose = button?.dataset?.textClose || 'Flod up'
        button.textContent = btnTextClose
      }
      button.style.display = 'block'
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  const filterItems = document.querySelectorAll('.filterDiv')
  const totalItems = filterItems.length

  if (totalItems > 3) {
    for (let i = totalItems - 3; i < totalItems; i++) {
      filterItems[i].classList.add('hide')
    }
  }

  applyFilters()
})

function toggleViewMore(button) {
  const parent = button.parentElement
  const items = parent.querySelectorAll('.filterDiv')
  const btnDomData = button.dataset
  console.log('this.dataset', button, button.dataset)

  // 检查元素数量，如果小于[LIMIT_SIZE]个则不执行隐藏逻辑
  if (items.length <= LIMIT_SIZE) {
    button.style.display = 'none'
    items.forEach((item) => item.classList.remove('dehide'))
    return
  }

  const hiddenItems = Array.from(items).slice(LIMIT_SIZE)

  let isAnyHidden = false
  hiddenItems.forEach((item) => {
    item.classList.toggle('dehide')
    if (item.classList.contains('dehide')) {
      isAnyHidden = true
    }
  })

  if (isAnyHidden) {
    button.textContent = btnDomData?.textOpen || 'View More'
  } else {
    button.textContent = btnDomData?.textClose || 'Fold Up'
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let allFilters = document.getElementsByClassName('filterDiv')
  for (let i = 0; i < allFilters.length; i++) {
    allFilters[i].style.display = 'block'
  }

  let checkboxes = document.querySelectorAll('#myBtnContainer input, #myBtnContainer1 input')
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      applyFilters(true)
    })
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.toggle-btn')
  const toggleTitle = document.querySelector('.filter-header > p')
  const toggleIconMore = document.querySelector('.toggle-btn > .more')
  const toggleIconLess = document.querySelector('.toggle-btn > .less')

  const toggleMenu1 = document.querySelector('#myBtnContainer .title')
  const toggleMenu2 = document.querySelector('#myBtnContainer1 .title')
  const leftMenu = document.getElementById('lm')
  let isCollapsed = true

  toggleBtn.addEventListener('click', function () {
    console.log(`%c>> $`, 'color:yellow', 111112)
    toggleTitle.innerHTML = isCollapsed ? 'Hide Filters' : 'Show Filters'
    toggleIconMore.style.display = isCollapsed ? 'none' : 'block'
    toggleIconLess.style.display = isCollapsed ? 'block' : 'none'

    if (isCollapsed) {
      leftMenu.classList.remove('collapsed')
    } else {
      leftMenu.classList.add('collapsed')
    }
    isCollapsed = !isCollapsed
  })
  toggleMenu1.addEventListener('click', function () {
    const isCollapsed = this.dataset.menuCollapsed
    this.dataset.menuCollapsed = isCollapsed === 'true' ? 'false' : 'true'
    console.log(`%c>> $toggleMenu1`, 'color:yellow', this, this.dataset)
  })
  toggleMenu2.addEventListener('click', function () {
    const isCollapsed = this.dataset.menuCollapsed
    this.dataset.menuCollapsed = isCollapsed === 'true' ? 'false' : 'true'
    console.log(`%c>> $toggleMenu2`, 'color:yellow', this, this.dataset)
  })
})
